export default __webpack_public_path__ + "static/media/DOLL_P5.75624265.svg";